// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__pLNyz","modal":"Modal_modal__dKo6c","slide-down":"Modal_slide-down__t+EDZ"};